import React from "react";
import "./home.css";
import "./style.css";
import { Link } from "react-router-dom";

function Ads({ ads }) {
  const scrollAmount1 = -1000;

  const handleScroll1 = () => {
    window.scrollBy({
      top: scrollAmount1,
      behavior: "smooth",
    });
  };

  const scrollAmount = -1600;

  const handleScroll = () => {
    window.scrollBy({
      top: scrollAmount,
      behavior: "smooth",
    });
  };

  return (
    <div>
      {ads.map((ad) => (
        <div key={ad.id}>
          <section id="advertisement" class="advertisement">
            <div class="advertisement-content">
              <h2>Don't Miss Out!</h2>
              <p>{ad.sub_title}!</p>
              <Link onClick={handleScroll1} class="cta-button">
                Shop Now
              </Link>
            </div>
          </section>
          <div id="publicity-section" className="publicity-container">
            <div className="publicity-content">
              <div className="publicity-image">
                <img src={ad.img_url} alt={ad.title} />
              </div>
              <div className="publicity-text">
                <h2>{ad.title}</h2>
                <p>{ad.description}</p>
                <Link onClick={handleScroll} className="publicity-button">
                  Shop Now
                </Link>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
export default Ads;
